import React from 'react';
import Icon from '@pushpay/icon';
import { useIllustrationBackgroundColor } from './use-illustration-background-color';
import { useThemeColors } from './use-theme-colors';

const AnalyticsIllustration = props => {
  const {
    background
  } = props;
  const backgroundColor = useIllustrationBackgroundColor(background);
  const {
    accentDark,
    accentLight,
    greyLight
  } = useThemeColors();
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 146 136"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.295 68.313c.077 1.169.142 2.348.195 3.535l.057 1.428c.017.477.032.956.045 1.435l.033 1.44c.038 2.164.033 4.342-.022 6.521l-.044 1.452c-.667 18.873-5.143 37.467-16.963 45.736-11.624 8.169-30.371 6.281-48.385 1.32l-1.402-.393a174.2 174.2 0 01-.7-.2l-1.395-.41-.696-.21-1.389-.425-.691-.217-1.379-.44c-.229-.073-.458-.148-.686-.222l-1.367-.452-.68-.229-1.354-.462-1.343-.47-.668-.236-1.327-.476a241.934 241.934 0 01-5.088-1.913l-1.731-.683c-18.91-7.563-33.544-16.717-43.641-29.625C3.449 79.832-2.168 60.963 2.846 46.554c3.052-8.835 10.092-15.988 18.376-21.99l.961-.688.485-.34.976-.673.491-.332.989-.658.996-.649.5-.32 1.006-.635 1.01-.625 1.014-.617 1.017-.608 1.02-.6 1.02-.59 1.531-.872 1.529-.854 2.028-1.112 1.557-.839c.517-.277 1.032-.55 1.546-.82l1.538-.802c.255-.132.51-.263.766-.393l1.526-.772C56.405 4.927 67.547.918 80.396.126c15.355-.889 33.095 2.814 45.101 14.261C135.37 23.8 141.33 38.405 144.01 56.28l.21 1.456a150.6 150.6 0 011.075 10.577z",
    fill: backgroundColor,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.863 66.211l.262 1.29.253 1.298.243 1.308h0l.233 1.316.222 1.324.107.664.205 1.332.193 1.337c.124.893.24 1.789.348 2.686l.154 1.347c.123 1.123.232 2.248.325 3.371l.104 1.348.088 1.346c.023.387.045.774.064 1.161l.051 1.159c.023.578.041 1.156.054 1.732l.02 1.15c.003.19.005.382.005.572v1.143c-.077 13.11-2.863 25.146-10.397 32.165-6.074 5.682-15.249 8.076-25.51 8.52l-1.104.04c-1.292.038-2.6.047-3.92.029l-1.134-.023h0l-1.14-.035a106.7 106.7 0 01-.572-.023l-1.146-.054h0l-1.15-.066h0l-1.154-.077c-.385-.028-.77-.058-1.157-.09l-1.158-.1h0l-1.16-.11-.582-.059-1.162-.125c-.387-.044-.775-.089-1.162-.135l-1.348-.169-.674-.088h0l-1.682-.235h0l-1.678-.25-.67-.106h0l-1.336-.217-1.331-.227-1.326-.235-1.319-.244-1.31-.25-1.303-.259-1.294-.265-1.283-.27c-21.298-4.555-38.008-11.327-50.181-23.065C7.223 95.334-.414 78.63 2.355 64.662c1.84-9.389 8.375-17.534 16.17-24.61l.887-.797.898-.788h0l.905-.778c.304-.258.608-.515.914-.77l.92-.76.924-.752.929-.743.932-.734.934-.726 1.401-1.072 1.4-1.053 1.609-1.191 1.351-.987 1.4-1.006c10.937-7.8 21.35-13.633 34.106-16.239 14.08-2.822 30.96-1.712 43.541 7.303 11.558 8.28 19.443 23.186 24.12 42.125l.348 1.446c.286 1.211.559 2.438.819 3.681z",
    stroke: accentLight,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.388 30.49)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: greyLight,
    d: "M18.962 13.78l1.929 2.298L4.038 30.22l-1.929-2.298zM48.208 1.696l2.265 1.968-17.058 19.622-2.264-1.968z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: greyLight,
    d: "M17.52 16.394l1.124-2.782 14.835 5.994-1.123 2.782z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: accentDark,
    cx: 3.5,
    cy: 28.417,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: accentDark,
    cx: 18.667,
    cy: 15.917,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: accentDark,
    cx: 32.75,
    cy: 20.833,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: accentDark,
    cx: 48.417,
    cy: 3.5,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.232 96.833c-.21 0-.404-.089-.58-.266-.176-.178-.264-.374-.264-.588V70.354c0-.213.088-.409.264-.587.176-.178.37-.267.58-.267h1.688c.21 0 .404.09.58.267.175.178.263.374.263.587V95.98c0 .214-.088.41-.263.588-.176.177-.37.266-.58.266h-1.688z",
    fill: greyLight
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.957 96.833c-.21 0-.404-.089-.58-.266-.176-.178-.264-.374-.264-.588V80.604c0-.213.088-.409.264-.587.176-.178.37-.267.58-.267h1.688c.21 0 .404.09.58.267.175.178.263.374.263.587V95.98c0 .214-.088.41-.263.588-.176.177-.37.266-.58.266h-1.688z",
    fill: accentDark
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.032 96.833c-.21 0-.404-.089-.58-.266-.176-.178-.264-.374-.264-.588V70.354c0-.213.088-.409.264-.587.176-.178.37-.267.58-.267h1.688c.21 0 .404.09.58.267.175.178.263.374.263.587V95.98c0 .214-.088.41-.263.588-.176.177-.37.266-.58.266h-1.688z",
    fill: greyLight
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.757 96.833c-.21 0-.404-.089-.58-.266-.176-.178-.264-.374-.264-.588V80.604c0-.213.088-.409.264-.587.176-.178.37-.267.58-.267h1.688c.21 0 .404.09.58.267.175.178.263.374.263.587V95.98c0 .214-.088.41-.263.588-.176.177-.37.266-.58.266h-1.688zM93.682 96.833c-.21 0-.404-.089-.58-.266-.176-.178-.264-.374-.264-.588V80.604c0-.213.088-.409.264-.587.176-.178.37-.267.58-.267h1.688c.21 0 .404.09.58.267.175.178.263.374.263.587V95.98c0 .214-.088.41-.263.588-.176.177-.37.266-.58.266h-1.688z",
    fill: accentDark
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.732 96.833c-.21 0-.404-.089-.58-.266-.176-.178-.264-.374-.264-.588V73.771c0-.214.088-.41.264-.587.176-.178.37-.267.58-.267h1.688c.21 0 .404.089.58.267.175.178.263.373.263.587v22.208c0 .214-.088.41-.263.588-.176.177-.37.266-.58.266h-1.688z",
    fill: greyLight
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.432 96.833c-.21 0-.404-.089-.58-.266-.176-.178-.264-.374-.264-.588v-8.541c0-.214.088-.41.264-.588.176-.178.37-.267.58-.267h1.688c.21 0 .404.09.58.267.175.178.263.374.263.588v8.541c0 .214-.088.41-.263.588-.176.177-.37.266-.58.266h-1.688z",
    fill: greyLight
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.382 96.606c-.21 0-.404-.137-.58-.41a1.629 1.629 0 01-.264-.9V82.199c0-.328.088-.628.264-.9.176-.273.37-.41.58-.41h1.688c.21 0 .404.137.58.41.175.272.263.572.263.9v13.097c0 .327-.088.628-.263.9-.176.273-.37.41-.58.41h-1.688z",
    fill: accentDark
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.544 102.072c.211 0 .405.09.58.267.176.178.264.374.264.588v1.708c0 .213-.088.41-.264.587-.175.178-.369.267-.58.267H58.076c-.492 0-.897-.16-1.213-.48-.317-.32-.475-.73-.475-1.228V65.343c0-.213.088-.409.264-.587.176-.178.37-.267.58-.267h1.688c.21 0 .404.09.58.267.175.178.263.374.263.587v36.73h49.781z",
    fill: accentDark
  }))));
};

export default AnalyticsIllustration;